module.exports = __webpack_public_path__ + "img/12.7b64caa0.png";